import * as React from "react";
import ReactDOMClient from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { MoralisProvider } from "react-moralis";
import App from "./App";

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container!);

const serverUrl = process.env.REACT_APP_SERVER_URL!;
const appId = process.env.REACT_APP_ID!;
root.render(
  <React.StrictMode>
    <MoralisProvider serverUrl={serverUrl} appId={appId}>
      <App />
    </MoralisProvider>
  </React.StrictMode>
);
